import { IonicConfig } from "@ionic/core";

export const CwtUserIonicConfig: IonicConfig = {
    mode: 'md',
    keyboardHeight: 0
}